//Imports
import {
	VIDEO_COLLECTION,
	LIKES_COLLECTION,
	SPEAKERS_COLLECTION,
	TRANSCIPT_COLLECTION
} from '../../../AppConstants/CollectionConstants';
import { SourceType, VideoType, LikeType } from '../../../AppConstants/TypeConstants';

// Firebase
import firebase, { firestore } from '../../../firebase/firebase';
const uniqid = require('uniqid');

const deleteTranscript = async (transcriptId, targetId) => {
	try {
		const docRef = firestore.collection(VIDEO_COLLECTION).doc(targetId);
		const transcriptRef = firestore.collection(TRANSCIPT_COLLECTION).doc(transcriptId);

		await firestore.runTransaction(async (transcation) => {
			let transcript = await transcation.get(transcriptRef);
			if (!transcript.exists) {
				let err = {
					code: 'NotValidTranscriptId',
					message: 'No TranscriptId Found'
				};
				throw err;
			}

			let doc = await transcation.get(docRef);
			if (!doc.exists) {
				let err = {
					code: 'NotValidId',
					message: 'No EventId Found'
				};
				throw err;
			}

			//delete transript
			transcation.delete(transcriptRef);

			//Update video doc
			transcation.update(docRef, {
				transcriptId: firebase.firestore.FieldValue.delete()
			});

			return;
		});
		return transcriptId;
	} catch (error) {
		console.log('Error :: ', error);
		throw error;
	}
};

const _delete = { deleteTranscript };

export default _delete;
